import React, { useState } from 'react';
import { Collapse, Button, CardBody, Card } from 'reactstrap';

/**
 * Simple accordion item used to toggle visibility of its children.
 * If `isOpen` and `setIsOpen` are provided, the component operates in
 * a controlled manner, otherwise it manages its own open state.
 *
 * @param {Object} props Component properties
 * @param {string} props.title Accordion header text
 * @param {React.ReactNode} props.children Content shown when expanded
 * @param {boolean} [props.isOpen] Controlled open state
 * @param {Function} [props.setIsOpen] Setter for controlled state
 * @param {boolean} [props.disabled=false] Whether the accordion is disabled (hides the entire accordion)
 */

// If `isOpen` and `setIsOpen` props are provided the component becomes
// controlled from the parent. Otherwise it falls back to its own local state.
/**
 * Accordion item component.
 * @component
 */
const AccordionItem = ({ title, children, isOpen: isOpenProp, setIsOpen: setIsOpenProp, disabled = false }) => {
    const [internalOpen, setInternalOpen] = useState(false);

    // If disabled, don't render the accordion at all
    if (disabled) {
        return null;
    }

    const isOpen = (typeof isOpenProp === 'boolean') ? isOpenProp : internalOpen;

    /**
     * Toggle the open state when the header is clicked.
     * Falls back to internal state if the component is uncontrolled.
     */
    const toggle = () => {
        if (typeof setIsOpenProp === 'function') {
            setIsOpenProp(!isOpen);
        } else {
            setInternalOpen(!internalOpen);
        }
    };

    return (
        <div>
            <h2 className="accordion-header w-100">
                <Button 
                    class="btn accordion-button fw-bold" 
                    onClick={toggle}
                    style={{
                        marginBottom: '1rem',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    <span>{isOpen ? '-' : '+'}</span>
                    <span>{title}</span>
                </Button>
                </h2>
                <Collapse isOpen={isOpen}>
                    <Card>
                        <CardBody>
                            {children}
                        </CardBody>
                    </Card>
                </Collapse>
        </div>
);
};

export default AccordionItem;
